// src/utils/resumeData.js

export const emptyResumeData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    linkedinUrl: '',
    professionalSummary: '',
    skills: [],
    experience: [
        { title: '', company: '', startDate: '', endDate: '', description: '' },
    ],
    education: [
        { degree: '', fieldOfStudy: '', school: '', graduationDate: '' },
    ],
    // dropdown fields
    disabilityStatus: '',
    veteranStatus: '',
    raceEthnicity: '',
    gender: '',
    sponsorshipRequired: '',
    workAuthorization: '',
};
